import { Outlet } from 'react-router-dom';
import { MashrabiyaPattern } from '@/components/common/MashrabiyaPattern';
import { Logo } from '@/components/common/Logo';
import { ScrollToTop } from '@/components/common/ScrollToTop';

/**
 * Centered auth shell used by Login / Register / Reset routes.
 */
export function AuthLayout() {
  return (
    <div className="relative flex min-h-svh items-center justify-center overflow-hidden bg-surface px-margin-mobile py-12">
      <ScrollToTop />
      <MashrabiyaPattern className="opacity-30" tone="text-primary/10" />
      <div className="relative z-10 w-full max-w-md">
        <div className="mb-8 flex justify-center">
          <Logo size={96} />
        </div>
        <div className="rounded-3xl border border-outline-variant/20 bg-surface-container-lowest p-8 shadow-xl">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
